// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';
import {Email} from './email';
import {Phone} from './phone';
import {Address} from './address';
import {KeyValueItem} from '../key-value-list';
import {addressType} from '../../enum/address-type';

export const Communication = t.struct({
    email: Email,
    homeFax: Phone,
    homePhone: Phone,
    mailingAddress: Address,
    mobilePhone: Phone,
    physicalAddress: Address,
    preferredLanguage: t.maybe(KeyValueItem),
    workFax: Phone,
    workPhone: Phone
}, {
    defaultProps: {
        email: new Email({}),
        homeFax: new Phone({}),
        homePhone: new Phone({}),
        mailingAddress: new Address({
            type: addressType.MAILING
        }),
        mobilePhone: new Phone({}),
        physicalAddress: new Address({
            type: addressType.PHYSICAL
        }),
        preferredLanguage: {
            key: 'en',
            value: 'English'
        },
        workFax: new Phone({}),
        workPhone: new Phone({})
    },
    name: 'Communication'
});

// todo: refactor

export const communicationFieldKeys = {
    EMAIL: 'email',
    HOME_FAX: 'homeFax',
    HOME_PHONE: 'homePhone',
    MOBILE_PHONE: 'mobilePhone',
    OFFICE_PHONE: 'officePhone',
    WORK_FAX: 'workFax',
    WORK_PHONE: 'workPhone'
};

export const addressKeys = {
    MAILING_ADDRESS: 'mailingAddress',
    PHYSICAL_ADDRESS: 'physicalAddress'
};
